import { InputType } from 'config'

export const OTHER_INCOME_TYPES = [
  'Accessory Unit Income',
  'Alimony',
  'Automobile Expense Account',
  'Boarder Income',
  'Capital Gains',
  'Child Support',
  'Disability',
  'Dividends / Interest',
  'Employment Related Assets',
  'Fannie Mae - Non-Borrower Household Income',
  'Foster Care',
  'Housing Allowance - Housing or Parsonage',
  'Housing Choice Voucher Program (Section 8)',
  'Mortgage Credit Certificate',
  'Mortgage Differential',
  'Notes Receivable Installment',
  'Other',
  'Public Assistance',
  'Restricted Stock',
  'Retirement - Defined Contribution Plan (IRA, 401k, etc.)',
  'Retirement - Pension',
  'Royalty Payment',
  'Separate Maintenance',
  'Social Security',
  'Temporary Leave',
  'Tip Income',
  'Trust',
  'Unemployment Benefits',
  'VA Benefits Non Educational',
] as const

export const OTHER_INCOME_FREQUENCY = [
  'Yearly',
  'Monthly',
  'Semi-Monthly',
  'Bi-Weekly',
  'Weekly',
  'Hourly',
  'Variable',
  'Other',
] as const

export const getOtherIncomeInputs = (borrowerOptions: Record<string, string>): Record<string, InputType> => ({
  borrowerSeperator: {
    title: 'Borrower',
    inputType: 'select',
    options: borrowerOptions,
    hasDefaultOption: true,
    required: true,
  },
  incomeType: {
    title: 'Income Type',
    inputType: 'select',
    options: [...OTHER_INCOME_TYPES],
    hasDefaultOption: true,
    required: true,
  },
  description: {
    title: 'Description',
    inputType: 'text',
  },
  amount: {
    title: 'Amount',
    inputType: 'text',
    type: 'thousandSep',
    prefix: '$',
  },
  selfEmployment: {
    title: 'Self Employment Income',
    inputType: 'checkbox',
  },
  frequency: {
    title: 'Frequency',
    inputType: 'select',
    options: [...OTHER_INCOME_FREQUENCY],
    hasDefaultOption: true,
  },
  atrNotes: {
    title: 'ATR Notes',
    inputType: 'textarea',
  },
  otherNotes: {
    title: 'Other Notes',
    inputType: 'textarea',
  },
})

export const otherIncomeColumnKeys = [
  'borrowerSeperator',
  'incomeType',
  'description',
  'amount',
  'selfEmployment',
  'frequency',
  'atrNotes',
  'otherNotes',
] as const

export const otherIncomeColumnHeaders: Record<string, string> = {
  borrowerSeperator: 'Borrower',
  incomeType: 'Income Type',
  selfEmployment: 'Self Emp.',
  atrNotes: 'ATR Notes',
  otherNotes: 'Other Notes',
}
